// project import
import Loadable from 'components/Loadable';
import EmailTemplateBlasts from 'pages/settings/templates/email-blasts';
import { retryDynamicImport } from 'utils/retryDynamicImport';
import AuthGuard from 'utils/route-guard/AuthGuard';

const MainLayout = Loadable(retryDynamicImport(() => import('layout/MainLayout')));
const DeveloperPage = Loadable(retryDynamicImport(() => import('pages/developer')));
const AllEvents = Loadable(retryDynamicImport(() => import('pages/reports/all-events')));
const AllContacts = Loadable(retryDynamicImport(() => import('pages/reports/all-contacts')));
const AllVenues = Loadable(retryDynamicImport(() => import('pages/reports/all-venues')));
const Event = Loadable(retryDynamicImport(() => import('pages/event')));
const Contact = Loadable(retryDynamicImport(() => import('pages/contact')));
const Venue = Loadable(retryDynamicImport(() => import('pages/venue')));
const Acts = Loadable(retryDynamicImport(() => import('pages/acts')));
const Tasks = Loadable(retryDynamicImport(() => import('pages/tasks')));
const AiAssistant = Loadable(retryDynamicImport(() => import('pages/ai-assistant')));
const ServiceTemplates = Loadable(
  retryDynamicImport(() => import('pages/settings/templates/services'))
);
const TermsTemplates = Loadable(retryDynamicImport(() => import('pages/settings/templates/terms')));
const EmailTemplates = Loadable(
  retryDynamicImport(() => import('pages/settings/templates/emails'))
);
const TagsSetup = Loadable(retryDynamicImport(() => import('pages/settings/templates/tags')));
const GigsReport = Loadable(retryDynamicImport(() => import('pages/reports/gigs')));
const SalesReport = Loadable(retryDynamicImport(() => import('pages/reports/sales')));
const SalesContactsReport = Loadable(
  retryDynamicImport(() => import('pages/reports/sales-contacts'))
);
const LeadsReport = Loadable(retryDynamicImport(() => import('pages/reports/leads')));
const DepositsReport = Loadable(retryDynamicImport(() => import('pages/reports/deposits')));
const ExpensesReport = Loadable(retryDynamicImport(() => import('pages/reports/expenses')));
const AiMailReporting = Loadable(
  retryDynamicImport(() => import('pages/reports/ai-mail-reporting'))
);
const TalentAccessBlasts = Loadable(
  retryDynamicImport(() => import('pages/settings/templates/talent-access-blasts'))
);
const TalentCosts = Loadable(
  retryDynamicImport(() => import('pages/settings/templates/talent-costs'))
);
const PaymentReminders = Loadable(
  retryDynamicImport(() => import('pages/settings/templates/payment-reminders'))
);

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/developer',
      element: <DeveloperPage />
    },
    { path: '/', element: <AllEvents /> },
    { path: '/contacts', element: <AllContacts /> },
    { path: '/venues', element: <AllVenues /> },
    { path: '/tasks', element: <Tasks /> },
    { path: '/assistant', element: <AiAssistant /> },
    {
      path: '/event/*',
      element: <Event />
    },
    {
      path: '/acts/*',
      element: <Acts />
    },
    {
      path: '/contact/*',
      element: <Contact />
    },
    {
      path: '/venue/*',
      element: <Venue />
    },
    {
      path: '/templates/services',
      element: <ServiceTemplates />
    },
    {
      path: '/templates/terms',
      element: <TermsTemplates />
    },
    {
      path: '/templates/emails',
      element: <EmailTemplates />
    },
    {
      path: '/templates/email-blasts',
      element: <EmailTemplateBlasts />
    },
    {
      path: '/templates/talent-access-blasts',
      element: <TalentAccessBlasts />
    },
    {
      path: '/templates/talent-costs',
      element: <TalentCosts />
    },
    {
      path: '/templates/payment-reminders',
      element: <PaymentReminders />
    },
    {
      path: '/tags/contacts',
      element: <TagsSetup />
    },
    {
      path: '/reports/gigs',
      element: <GigsReport />
    },
    {
      path: '/reports/sales',
      element: <SalesReport />
    },
    {
      path: '/reports/sales-contacts',
      element: <SalesContactsReport />
    },
    {
      path: '/reports/leads',
      element: <LeadsReport />
    },
    {
      path: '/reports/deposits',
      element: <DepositsReport />
    },
    {
      path: '/reports/expenses',
      element: <ExpensesReport />
    },
    {
      path: '/reports/ai-mail-reporting',
      element: <AiMailReporting />
    }
  ]
};

export default MainRoutes;
